<template>
  <div class="page">
    <navigation class="header">活动规则</navigation>
    <div class="body">
      <div class="activity-time">
        活动时间：长期有效
      </div>
      <div class="section" v-for="(item, index) in rules" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc">
          <div v-html="item.desc"></div>
        </div>
      </div>
    </div>
    <footer>活动所有解释权归天美贷所有</footer>
  </div>
</template>

<script>
export default {
  name: 'interest-free-rule',
  data () {
    return {
      rules: [
        {
          title: '活动对象',
          desc: '天美贷新注册用户'
        },
        {
          title: '活动内容',
          desc:
            `活动期间，活动资格用户完成授信申请可获得现金红包福利`
        },
        {
          title: '奖品使用规则及发放方式',
          desc:
            `1、发放规则：用户完成授信申请，现金红包将直接发放至“我的券包”，请登录“天美贷APP或天美贷微信公众号-我的-我的券包-红包”进行查看<br/>
            2、领取规则：用户获得现金红包后的15日内，在天美贷（不含天美贷推荐的贷款产品）提现成功后，即可到“我的券包”进行提现，用户操作提现后的5个工作日内打到用户绑定的银行卡<br/>
            3、红包有效期：自发放红包之日起计算，30日内有效，如超过时间未提取则奖品失效`
        },
        {
          title: '奖品查看方式',
          desc:
            '您可以通过天美贷APP-我的-我的券包-红包进行查看'
        }
      ]
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: #F7E0B4;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
      flex-shrink: 0;
  }
  .body {
    background: #fff;
    margin: 40px 40px;
    border-radius: 30px;
    padding: 0 20px 213px 30px;
    .activity-time {
      margin-top: 71px;
      font-size: 32px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: #333;
      line-height: 45px;
    }
    .section {
      .title {
        margin-top: 60px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        line-height: 45px;
      }
      .desc {
        border-radius: 16px;
        background-color: #fff;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        margin-top: 10px;
      }
    }
  }

  footer {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #BFA36C;
    line-height: 30px;
    text-align: center;
    margin-top: 21px;
    margin-bottom: 45px;
  }
}
</style>